import * as types from '@/store/mutationTypes';

export const mutations = {
    [types.CHANGE_LOGIN_FORM](state, form) {
        state.loginFormView = form;
    }
};


// WEBPACK FOOTER //
// ./src/store/modules/login/mutations.js